import type { MetaFunction } from 'react-router'
import IndustriesPage from '~/pages/IndustriesPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Industries | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'S.J.S. Technology serves signage, textile, packaging, interior decoration, vehicle wrapping, and industrial marking industries with VICTORY machines.',
  },
  { property: 'og:title', content: 'Industries | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/industries' },
]

export default function Industries() {
  return <IndustriesPage />
}
